<!-- src/app/queries-list/queries-list.component.html -->
<div class="queries-container">
  <div class="queries-header">
  </div>
  
  <div class="queries-content">
    <div class="list-header">
      <h5>List of Documents</h5>
      
      <div class="list-actions">
        <div class="search-box">
          <div class="input-group">
            <span class="input-group-text bg-transparent"><i class="bi bi-search"></i></span>
            <input 
              type="text" 
              class="form-control" 
              placeholder="Search..." 
              [(ngModel)]="searchTerm"
              (ngModelChange)="search()">
          </div>
        </div>
      </div>
    </div>
    
    <div class="queries-table" *ngIf="filteredQueries.length > 0">
      <table class="table">
        <thead>
          <tr>
            <th class="thdata" scope="col">Name</th>
            <th class="thdata" scope="col">Shared On</th>
            <th class="thdata" scope="col">Shared By</th>
            <th class="thdata" scope="col">Message</th>
            <th class="thdata" scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let query of getPaginatedqueries() | filter:searchTerm">
            <td>{{ query.name }}</td>
            <td>{{ query.created }}</td>
            <td>{{ query.uploaded_by }}</td>
            <td>{{ query.description }}</td>
            <td>
              <div class="dropdown actions-dropdown">
                <button class="btn actions-menu" type="button" id="leadActions{{query.id}}" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="bi bi-three-dots-vertical"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end" [attr.aria-labelledby]="'leadActions' + query.id">
                  <li><a class="dropdown-item" href="javascript:void(0)" (click)="viewDocument(query)">
                    <i class="bi bi-eye"></i> &nbsp; View 
                  </a></li>
                  <li><a class="dropdown-item" href="javascript:void(0)" (click)="attachMatter(query)">
                    <i class="bi bi-paperclip"></i> &nbsp; Attach To Matter
                  </a></li>
                  <li><a class="dropdown-item" href="javascript:void(0)" (click)="downloadDocument(query)">
                    <i class="bi bi-download"></i> &nbsp; Download
                  </a></li>
                  <!-- <li><a class="dropdown-item" href="javascript:void(0)" (click)="delDocument(query)">
                    <i class="bi bi-trash"></i> &nbsp; Delete
                  </a></li> -->
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="pagination-area" *ngIf="filteredQueries.length > 0">
      <div class="pagination-info">
        {{ getPaginationRange() }}
      </div>
      
      <nav aria-label="Leads pagination">
        <ul class="pagination mb-0">
          <li class="page-item" [ngClass]="{'disabled': currentPage === 1}">
            <a class="page-link" href="javascript:void(0)" (click)="changePage(currentPage - 1)">
              <i class="bi bi-chevron-left"></i> Previous
            </a>
          </li>
          
          <li *ngFor="let page of getPageNumbers()" class="page-item" [ngClass]="{'active': page === currentPage}">
            <a class="page-link" href="javascript:void(0)" (click)="changePage(page)">{{ page }}</a>
          </li>
          
          <li class="page-item" [ngClass]="{'disabled': currentPage === getTotalPages() || getTotalPages() === 0}">
            <a class="page-link" href="javascript:void(0)" (click)="changePage(currentPage + 1)">
              Next <i class="bi bi-chevron-right"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>

    <div *ngIf="filteredQueries.length === 0">
      <div colspan="6" class="text-center noleads">No Documents Found!!</div>
    </div>

  </div>
</div>


    <!-- <iframe *ngIf="pdfSrc" height="100%" width="100%" [src]="pdfSrc"></iframe> -->
